import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AwardsService } from '@core/services/awards/awards.service';
import { take } from 'rxjs';

export interface GlossaryData {
  title?: string;
  content?: any[];
}

@Component({
  selector: 'app-glossary-modal',
  templateUrl: './glossary-modal.component.html',
  styleUrls: ['./glossary-modal.component.scss']
})
export class GlossaryModalComponent implements OnInit {
  glossaryData: any[] = [];
  loading = true;
  error = false;

  constructor(
    public readonly dialogRef: MatDialogRef<GlossaryModalComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: GlossaryData,
    private readonly awardsService: AwardsService
  ) {}

  ngOnInit(): void {
    this.loadGlossaryData();
  }

  loadGlossaryData(): void {
    this.loading = true;
    this.error = false;
    
    this.awardsService.getAllGlossaryRebate()
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          this.glossaryData = res || [];
        },
        error: (err: any) => {
          this.loading = false;
          this.error = true;
        }
      });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  formatTerm(term: string): string {
    if (!term) return '';
    
    const trimmedTerm = term.trim().toLowerCase();
    
    // Solo capitalizar la primera letra del término completo
    return trimmedTerm.charAt(0).toUpperCase() + trimmedTerm.slice(1);
  }
}